import { Input, Modal, message } from 'antd';
import Utils from '@utils/utils'
import { useEffect, useState } from 'react';
import eventBus from '@utils/eventBus';
import styles from './inviteUserModal.module.scss'

const InviteModal = (props) => {
    const [open, setOpen] = useState(false)

    const handleInvite = () => {
        setOpen(true)
    }

    useEffect(() => {
        eventBus.on('inviteUser', handleInvite);
        return () => {
            eventBus.off('inviteUser', handleInvite);
        }
    }, [])

    const onCancelClick = () => {
        setOpen(false)
    }

    const copyClick = (text) => {
        const textarea = document.createElement('textarea');
        textarea.value = text
        document.body.appendChild(textarea);

        textarea.select();
        document.execCommand('copy');

        document.body.removeChild(textarea);

        message.success('已复制邀请码，快去邀请朋友注册吧！')
    }
    
    return (
        <Modal
            title={null}
            footer={null}
            centered
            destroyOnClose
            open={open}
            getContainer='#root'
            width={680}
            wrapClassName={styles.InviteModal}
            onCancel={onCancelClick}
            // onOk={okClick}
        >
            <div className={styles.InviteModal_body}>
                <div className={styles.copy_box}>
                    <Input placeholder='您暂无邀请码' value={props.invitationCode} />
                    <div className={styles.copy_box_btn} 
                    onClick={() => copyClick(props.invitationCode)}>去邀请</div>
                </div>
            </div>
        </Modal>
    )
}

export default InviteModal